<template>
    <div
        class="promotion-allocation-area__data promotion-allocation-area__grid-cell--button"
        :class="colourClass"
    >
        <simple-button :disabled="isDisabled" @click.stop="handleSelect">
            {{ buttonText }}
        </simple-button>
    </div>
</template>

<script>
import { toSentenceCase } from '@/js/utils/string-utils';
import promotionCellRendererMixin from './promotion-cell-renderer-mixin';

export default {
    name: 'PromotionSelectButtonRenderer',
    mixins: [promotionCellRendererMixin],
    computed: {
        isDisabled() {
            return this.params.isPromotionDisabled(this.params.data);
        },
        buttonText() {
            return toSentenceCase(this.$t('preparation.buttons.select'));
        },
    },
    methods: {
        handleSelect(event) {
            this.params.setPromotion(this.params.data, event);
        },
    },
};
</script>
